<template>

    <v-page-body>

        <transition name="modal">
            <v-modal-key-create v-if="showModal === 'create'" method="create" @created="getKeys" />
            <v-modal-key-delete v-if="apiKey && showModal === 'delete'" :api-key="apiKey" @deleted="getKeys" />
            <v-modal-key-edit v-if="apiKey && showModal === 'edit'" :api-key="apiKey" @saved="getKeys" />
        </transition>

        <v-page-section padded>
            <template #header>
                <span>Standard Keys</span>
                <v-identifier :uuid="project.id" />
            </template>
            <template #body>
                <v-table :selectable="false" bordered>
                    <thead>
                        <th>Name</th>
                        <th>Token</th>
                        <th>Last Used</th>
                        <th>Created</th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr v-for="apiKey in standardKeys" :key="apiKey.id">
                            <td :title="apiKey.name"><div class="w-160 text-overflow">{{ apiKey.name }}</div></td>
                            <td><v-copy-box class="mt-5 mb-5" dark>{{ apiKey.token }}</v-copy-box></td>
                            <td v-if="apiKey.last_used_at">{{ apiKey.last_used_at | relativeTime }}</td><td v-else>&mdash;</td>
                            <td>{{ apiKey.created_at | relativeTime }}</td>
                            <td><v-button size="xs" btn-style="white" @click.native="editKey(apiKey)">Edit</v-button></td>
                        </tr>
                    </tbody>
                </v-table>
            </template>
        </v-page-section>

        <v-page-section padded>
            <template #title>Application Keys</template>
            <template #body>
                <v-notice v-if="!applicationKeys.length" size="sm" message="No Application Keys" />
                <v-table v-else :selectable="false" bordered>
                    <thead>
                        <th>Name</th>
                        <th>Token</th>
                        <th>Last Used</th>
                        <th>Created</th>
                        <th></th>
                    </thead>
                    <tbody>
                        <tr v-for="apiKey in applicationKeys" :key="apiKey.id">
                            <td :title="apiKey.name"><div class="w-160 text-overflow">{{ apiKey.name }}</div></td>
                            <td><v-copy-box class="mt-5 mb-5" dark>{{ apiKey.token }}</v-copy-box></td>
                            <td v-if="apiKey.last_used_at">{{ apiKey.last_used_at | relativeTime }}</td><td v-else>&mdash;</td>
                            <td>{{ apiKey.created_at | relativeTime }}</td>
                            <td><v-button size="xs" btn-style="white" @click.native="editKey(apiKey)">Edit</v-button></td>
                        </tr>
                    </tbody>
                </v-table>
            </template>
            <template #footer>
                <v-button size="xs" btn-style="white" @click.native="createKey">Create Application Key</v-button>
            </template>
        </v-page-section>

    </v-page-body>

</template>

<script>

import axios from 'axios';
import ModalKeyCreate from '@modals/key/ModalKeyCreate';
import ModalKeyDelete from '@modals/key/ModalKeyDelete';
import ModalKeyEdit from '@modals/key/ModalKeyEdit';
import ProjectApi from '@api/ProjectApi';

export default {

    components: {
        'v-modal-key-create': ModalKeyCreate,
        'v-modal-key-delete': ModalKeyDelete,
        'v-modal-key-edit': ModalKeyEdit,
    },

    data() {
        return {
            apiKeys: [],
            apiKey: null,
        }
    },

    computed: {

        standardKeys() {
            return [
                this.apiKeys.find(k => k.type === 'pk'),
                this.apiKeys.find(k => k.type === 'sk'),
            ]
        },

        applicationKeys() {
            return this.apiKeys.filter(k => k.type === 'ak');
        },

    },

    mounted() {
        this.$store.commit('loading', true);
        let requests = [
            ProjectApi.getProject(this.project.id),
            ProjectApi.getKeys(this.project.id),
        ];
        axios.all(requests)
            .then(axios.spread((resProject, resKeys) => {
                this.$store.commit('loading', false);
                this.apiKeys = resKeys.data.data;
                this.$events.$emit('pageLoaded');
            }), () => {
                this.$store.commit('loading', false);
                this.$events.$emit('pageError');
            });
    },

    methods: {

        getProject() {
            this.$store.commit('loading', true);
            ProjectApi.getProject(this.project.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.project = response.data.data;
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        getKeys() {
            this.$store.commit('loading', true);
            ProjectApi.getKeys(this.project.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.apiKeys = response.data.data;
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        createKey() {
            this.$store.commit('showModal', 'create');
        },

        editKey(apiKey) {
            this.apiKey = apiKey;
            this.$store.commit('showModal', 'edit');
        },

        deleteKey(apiKey) {
            this.apiKey = apiKey;
            this.$store.commit('showModal', 'delete');
        },

    },

}

</script>